import CustomLabel from "components/common/CustomLabel";
import DetailsPageTitle from "components/common/DetailsPageTitle";
import NoDataFound from "components/common/NoDataFound";
import SingleSelect from "components/common/SingleSelect";
import Spinners from "components/common/Spinners";
import { formatDate } from "components/common/Utils";
import React, { useEffect, useState } from "react";
import { Badge, Col, Container, Row, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { getRolesList } from "store/actions/rolesSlice";
import { getUserDetails, updateUser } from "store/actions/userSlice";
import { showAlert } from "store/reducers/alertReducer";

const UserDetails = () => {
  const { t } = useTranslation();
  document.title = t("User Details | Work Space");

  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const dispatch = useDispatch();

  const { gettingDetails, isLoading, userDetails } = useSelector(
    (state) => state.Users
  );
  const { rolesList } = useSelector((state) => state.Roles);

  const [selectedRoleId, setSelectedRoleId] = useState(null);

  useEffect(() => {
    const getDetails = () => {
      const payload = {
        id,
      };
      dispatch(getUserDetails(payload));
    };
    getDetails();
    fetchRolesList();
  }, []);

  useEffect(() => {
    if (userDetails) {
      const { _id } = userDetails?.role || {};
      _id && setSelectedRoleId(_id);
    }
  }, [userDetails]);

  const fetchRolesList = () => {
    dispatch(getRolesList());
  };

  const handleUpdateRole = () => {
    const { name, email, phoneNumber } = userDetails;
    const payload = {
      id,
      name,
      email,
      phoneNumber,
      role: selectedRoleId,
    };

    dispatch(updateUser(payload))
      .then((action) => {
        const { statusCode, success, message } = action?.payload;
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }));
        } else {
          dispatch(showAlert({ text: message, type: "error" }));
        }
      })
      .catch((err) => {});
  };

  return (
    <React.Fragment>
      <div className="page-content common_details_page user_details">
        {gettingDetails ? (
          <Spinners />
        ) : (
          <Container fluid>
            <Row>
              <DetailsPageTitle title={t("User Details")} />
            </Row>
            <div className="common_wrapper">
              <Row>
                <Col lg={6}>
                  <div className="left_section inner_section">
                    <div className="d-flex gap-5 align-items-center">
                      <h2 className="fs_24">{userDetails.name || "-"}</h2>
                      <Badge
                        bg={
                          userDetails.status === 1
                            ? " bg_primary"
                            : " bg-secondary"
                        }
                      >
                        {userDetails.status === 1 ? t("Active") : t("Deactive")}
                      </Badge>
                    </div>
                    <p className="text_gray fs_12 mt-1">
                      {userDetails?.email || "-"}
                    </p>
                    <div className="mt-4 d-flex  gap-5">
                      <div>
                        <p className="text_gray fs_12 mt-1">
                          {t("First seem")}
                        </p>
                        <h2 className="text_black fs_16 mt-1">
                          {formatDate(userDetails?.createdAt)}
                        </h2>
                      </div>
                      <div>
                        <p className="text_gray fs_12 mt-1">{t("Last seem")}</p>
                        <h2 className="text_black fs_16 mt-1">
                          {formatDate(userDetails?.updatedAt)}
                        </h2>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="right_section inner_section">
                    <div className="form_field">
                      <CustomLabel htmlFor="role" label={t("Role")} />
                      <SingleSelect
                        options={rolesList?.map((item) => ({
                          name: item?.name,
                          value: item?._id,
                        }))}
                        value={selectedRoleId}
                        placeholder={t("Role Type")}
                        handleSingleSelectChange={(e) => {
                          setSelectedRoleId(e.value);
                        }}
                      />
                    </div>
                    <div className="g_end">
                      <button
                        type="submit"
                        className="main_btn "
                        disabled={isLoading || !selectedRoleId}
                        onClick={handleUpdateRole}
                      >
                        {t("Save")}
                      </button>
                    </div>
                  </div>
                </Col>
                {userDetails?.accountType !== "superadmin" && (
                  <Col lg={6} className="mt-4">
                    <div className="left_section inner_section">
                      <h2 className="fs_24 mb-2">{t("Assigned Branches")}</h2>

                      {userDetails?.branchDetails?.length === 0 ? (
                        <NoDataFound />
                      ) : (
                        <div style={{ maxHeight: 400, overflow: "auto" }}>
                          <Table>
                            <thead className="t_head">
                              <tr>
                                <th>{t("#")}</th>
                                <th>{t("Branch Name")}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {userDetails?.branchDetails?.map(
                                (item, index) => (
                                  <tr key={item?._id}>
                                    <td>{index + 1}</td>
                                    <td>{item.name}</td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </Table>
                        </div>
                      )}
                    </div>
                  </Col>
                )}
              </Row>
            </div>
          </Container>
        )}
      </div>
    </React.Fragment>
  );
};

export default UserDetails;
